import { useRoleAliases } from '@/features/settings/useSettings';

import { applyRoleAlias, toDisplayRole } from './roles';

/**
 * SCRUM-465 — the tenant-alias-aware role-name resolver. Returns a function
 * that maps a stored OR display role string to the name the current tenant
 * should see: the tenant's per-role alias when set, otherwise the built-in
 * display name.
 *
 * Backed by the shared `useRoleAliases` react-query cache (owned in
 * useSettings), so a Settings save invalidates that key and every consumer of
 * this hook re-renders with the new alias — no stale-name bug.
 *
 * Keep this the ONLY alias-aware seam; `toDisplayRole` / `applyRoleAlias` stay
 * pure. `toDisplayRole` is idempotent on inputs that are already display roles
 * (they aren't keys in STORED_TO_DISPLAY), so callers can pass either a stored
 * SystemRole value or an already-resolved display role.
 */
export function useDisplayRole(): (role: string) => string {
  const { aliases } = useRoleAliases();
  return (role: string) => applyRoleAlias(toDisplayRole(role), aliases);
}
